import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/main.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { initTheme } from './composables/useTheme';

initTheme();

createApp(App).use(router).mount('#app');

// Enable theme transitions after first paint to avoid FOUC animation
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.documentElement.classList.add('theme-ready');
  });
});
